export const INITIAL_FONT_SIZE = 1;

export const STORAGE_KEY = "MOBIDYS_SLIDER_FONT_SIZE";
